import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Theme,
  Chip,
  ListItem,
  List,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import {
  IReduxState,
  IExtendedMachineTagOption,
  AccessLevel,
} from '../../types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import EditMachineTags from './EditMachineTags';
import MachineNotes from './MachineNotes';
import { chartColors, themeColors } from '../../constants';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    zIndex: 1,
    flexGrow: 1,
  },
  card: {
    [theme.breakpoints.up('xs')]: {
      margin: `${theme.spacing(2)}px 0`,
    },
    [theme.breakpoints.up('sm')]: {
      height: 400,
      margin: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
    },
  },
  cardFormat: {
    height: '100%',
    boxShadow: `0.25rem 0.25rem 0 0 ${chartColors.electricBlue}`,
    backgroundColor: `${themeColors.topIndexGray}`, 
  },
  cardContent: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  list: {
    height: '100%',
    overflowY: 'auto',
    width: '100%',
  },
  tagsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  // Neue Klasse speziell f�r die Tags mit max. 2 Zeilen + Scrollbar
  tagsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: 80,                    // ca. 2 Zeilen (je nach Chip-H�he)
    overflowY: 'auto',                 // Vertikaler Scrollbar nur bei Bedarf
    overflowX: 'hidden',
    paddingRight: '8px',               // Platz f�r Scrollbar

    // Sch�ner Scrollbar
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[400],
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.grey[500],
      },
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },

    // Firefox
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.grey[400]} transparent`,
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyItems: 'space-around',
  },
}));

export default function MachineTagsNotes() {
  const classes = useStyles();
  const { t } = useTranslation();
  const machine = useSelector(
    (state: IReduxState) => state.machineDetails.machine
  );
  const machineTagOptions: IExtendedMachineTagOption[] = useSelector(
    (state: IReduxState) => state.search.machineTagOptions
  );
  const isHybrid = useSelector(
    (state: IReduxState) =>
      // !!state.machineDetails.machine.telemetrySnapshot?.isHybrid
      !!state.machineDetails.machine.isHybrid
  );
  const currentlyAuthenticatedUserAccessLevel = useSelector(
    (state: IReduxState) =>
      state.machineDetails.machine.currentlyAuthenticatedUserAccessLevel
  );
  const [machineTags, setMachineTags] = useState<IExtendedMachineTagOption[]>();

  // console.log("******************************************************");
  // console.log("In MachineTagsNotes");
  // console.log("******************************************************");
  // console.log("currentlyAuthenticatedUserAccessLevel : " + currentlyAuthenticatedUserAccessLevel);

  useEffect(() => {
    const tags = machine.tags;
    const machineTags = tags
      ? tags.map((machineTag: any) => { 
       const color = machineTagOptions.length
            ? machineTagOptions.filter(
                (tagOption: any) => tagOption.id === machineTag.id
              )[0].color
            : themeColors.yellow;
          return {
            id: machineTag.id,
            key: machineTag.key,
            color,
          };
        })
      : [];
    setMachineTags(machineTags);
  }, [machineTagOptions, machine.tags]);

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <Card 
          className={classes.cardFormat}
          style={{
            paddingBottom: 0,
            boxShadow: isHybrid 
              ? `0.25rem 0.25rem 0 0 ${chartColors.electricBlue}`
              : 'none',
          }}
        >
          <CardContent
            className={classes.cardContent}
            style={{ paddingBottom: 0 }}
          >
            <List className={classes.list}>
              <ListItem dense alignItems="flex-start">
                <div className={classes.title}>
                  <Typography gutterBottom variant="h6">
                    {t('machine.machineTags')}
                  </Typography>
                  { 
                    currentlyAuthenticatedUserAccessLevel === AccessLevel.Write 
                    && <EditMachineTags />
                  }
                </div>
              </ListItem>
              {/* <ListItem>
                <div className={classes.tagsWrapper}>
                  {!!machineTags &&
                    machineTags.map((item: any, index: number) => {
                      return (
                        <Chip
                          variant="outlined"
                          style={{
                            borderWidth: '2px',
                            borderColor: item.color,
                            color: item.color,
                            margin: '4px',
                          }}
                          key={`tag-${index}-${item}`}
                          label={item.key}
                        />
                      );
                    })}
                </div>
              </ListItem> */}
              {/* Tags mit max. 2 Zeilen + vertikalem Scrollbar */}
              <ListItem>
                <div className={classes.tagsContainer}>
                  {!!machineTags &&
                    machineTags.map((item: any, index: number) => (
                      <Chip
                        key={`tag-${index}`}
                        variant="outlined"
                        style={{
                          borderWidth: '2px',
                          borderColor: item.color,
                          color: item.color,
                          margin: 0,                    // margin wird durch gap im Container gesteuert
                        }}
                        label={item.key}
                      />
                    ))}
                </div>
              </ListItem>
                <MachineNotes />
            </List>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
